document.addEventListener("DOMContentLoaded", function () {
    // Select all <ul> elements with the class 'footer-list-links'
    // or
    // Select all <ul> elements with the class 'cf-menu-list'
    // const footerLists = document.querySelectorAll(".footer-list-links");
    const footerLists = document.querySelectorAll(".cf-menu-list");
  
    footerLists.forEach(list => {
      // Find all <li> elements inside each <ul>
      const listItems = list.querySelectorAll("li");
  
      listItems.forEach(li => {
        // const span = li.querySelector("span");
        const link = li.querySelector(".cf-menu-link");
        if (link && link.textContent.trim() === "Accessibility") {
          // Replace the entire <a> tag with the custom one
          const newLink = document.createElement("a");
          newLink.id = "INDmenu-btn";
          newLink.accessKey = "m";
          newLink.setAttribute("aria-labelledby", "INDbtnTooltip");
          newLink.className = "accessibilityLink";
          newLink.setAttribute("data-acsb", "trigger");
          newLink.tabIndex = 0;
          newLink.role = "button";
          newLink.textContent = "Accessibility";
  
          // Remove existing <a> tag
          const oldLink = li.querySelector("a");
          if (oldLink) {
            li.removeChild(oldLink);
          }
  
          // Append the new link
          li.appendChild(newLink);
        }
      });
    });
  });